import {Component, Input} from '@angular/core';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AQH_EVE_15, AQH_EVE_20} from '../../../../../../../../../../@shared/models/input.module';
import {EventResponse, SponsorResponse} from '../../../../../../../../../../@shared/models/response.module';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../../../../../../../../../@core/services/toast.service';

@Component({
  selector: 'app-add-sponsor',
  standalone: false,
  templateUrl: './add-sponsor.html',
  styleUrl: './add-sponsor.css'
})
export class AddSponsor {
  @Input() event: EventResponse

  sponsor_name = '';
  sponsor_description = '';

  logoFile: File | null = null;
  imageFile: File | null = null;

  submitted = false;
  saving = false;

  constructor(private eventsService: EventsService,
              private modal: NgbActiveModal,
              private translateService: TranslateService,
              private toastService: ToastService) {
  }

  // Validation helpers
  get isSponsorNameInvalid(): boolean {
    return this.submitted && !this.sponsor_name.trim();
  }

  get isFormValid(): boolean {
    return !!this.sponsor_name.trim();
  }

  onSave() {
    this.submitted = true;

    if (!this.isFormValid) {
      this.toastService.error(this.translateService.instant('manageEvent.addSponsor.validationError'));
      return;
    }

    this.saving = true;

    const payload: AQH_EVE_15 = {
      sponsor_name: this.sponsor_name.trim(),
      sponsor_description: this.sponsor_description.trim(),
    };

    this.eventsService.createSponsor(payload).subscribe({
      next: (res: any) => {
        console.log('Sponsor created:', res);
        const sponsor: SponsorResponse = res.data;

        // Upload logo if provided
        if (this.logoFile && sponsor) {
          let logoPayload: AQH_EVE_20 = {
            sponsor_id: sponsor.sponsor_id,
            image_type: 'logo',
            image: this.logoFile
          }
          this.eventsService.uploadSponsorImage(logoPayload).subscribe(() => {
            console.log('Logo uploaded')
          });
        }

        // Upload banner image if provided
        if (this.imageFile && sponsor) {
          let imagePayload: AQH_EVE_20 = {
            sponsor_id: sponsor.sponsor_id,
            image_type: 'image',
            image: this.imageFile
          }
          this.eventsService.uploadSponsorImage(imagePayload).subscribe(() => {
            console.log('Image uploaded')
          });
        }

        this.saving = false;
        this.toastService.success(this.translateService.instant('manageEvent.addSponsor.success'));
        // Return the sponsor data so parent components can decide where to add it
        this.modal.close(sponsor);
      },
      error: (err) => {
        this.saving = false;
        console.error('Error creating sponsor:', err);
        this.toastService.error(err?.error?.reason || this.translateService.instant('manageEvent.addSponsor.error'));
      }
    });
  }

  close() {
    this.modal.close();
  }
}
